import ShDividerLine from '@/components/Helpers/ShDividerLine';
import EmptyListOnStartup from '@/components/Common/EmptyListOnStartup';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import AgentsListItem from './AgentsListItem';
import HintAndExplanation from '@/components/Common/HintAndExplanation';

// @vue/component
export default {
  name: 'AgentsList',

  components: {
    ShDividerLine,
    AgentsListItem,
    EmptyListOnStartup,
    AddNewElementButton,
    HintAndExplanation,
  },


  computed: {
    possibleNumberOfAgentsAccordingToAccessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'].global_options.number_of_agents;
    },
    isWaitingForAgentsList() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/getList',
        'agents/update',
        'agents/delete',
      ]);
    },
    isEmpty() {
      return this.agentsList.length === 0;
    },
    possibleNumberToAssign() {
      return this.$store.getters['numbers/list']
        .filter(number => number.is_verified)
        .filter(number => !number.assigned_to_agent_id)
        .length;
    },
    agentsList() {
      return this.$store.getters['agents/list'];
    },
    agentsFeedbackList() {
      return this.$store.getters['agents/feedbacksList'];
    },
  },

  created() {
    this.$store.dispatch('agents/getList');
    this.$store.dispatch('agents/getFeedbackList');
  },
};
